import React from 'react';
import Helpers from './Helpers.js'

import './StateView.css';


class StateView extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
		   
		}
	}


	render() {
		let statePartyCode = '';
		if(this.props.state.candidates.winner!=="none" && this.props.state.candidates.winner!=="") {
			statePartyCode = this.props.parties.o[this.props.state.candidates.o[this.props.state.candidates.winner].party].partycode;
		}
		//if(this.props.state.candidates.a.length>0) {
		if(this.props.state.electors>0) {
			return(
				<div className={"stateBox stateBox_"+statePartyCode + " stateBox_"+this.props.show}>
					<h6 className='stateName'>
						{this.props.state.name}
					</h6>
					<div className='stateBoxInfo'>
						{
							this.props.state.notes.length>1
							? <div className='state-notes'><b>{this.props.state.notes}</b></div>
							: false
						}
						{
							this.props.show==="polls"
							? <div className= {'polls polls-'+this.props.state.polls}><b>{this.props.polls[this.props.state.polls].label}</b></div>
							: false
						}
						{this.props.state.candidates.winner !== "none" && this.props.state.candidates.winner.length > 3
						 ? <div> Gewinner: <b className='winner'>{this.props.state.candidates.winner}</b> </div>
						 : false
						}
						<div className='electors'>
							Elektoren: <b>{this.props.state.electors}</b>
						</div>
						{
							this.props.state.totals.votes*1>0
							? <div>Stimmen Total: {Helpers.tsnds(this.props.state.totals.votes)}</div>
							: false
						}
						{
							this.props.state.counted*1>0
							? <div className='counted'>{this.props.state.counted}% gezählt</div>
							: false
						}
					</div>
					<div className='stateCandidatesBox'>

						<ol className='candidateList'>
						{
							this.props.state.candidates.a.map((candidate,k_0) => {
								if(candidate.percent*1<=0) {
									candidate.percent = Helpers.getPercent(this.props.state.totals.votes,candidate.votes)
								}
								if(candidate.percent*1+candidate.votes*1+candidate.electors*1>0) {
									return(
										<li key = {k_0} className={'stateParty '+this.props.parties.o[candidate.party].partycode}>
											<h6 className='candidate-name'>{candidate.name}</h6>
											<div className='candidate-info'>
												{candidate.party}
												<br/>
												{
													candidate.percent*1>0
													? <span>Stimmen: <b>{candidate.percent}% </b> </span>
													: false
												}
												{
													candidate.votes*1>0
													? <span>&nbsp; <b>{Helpers.tsnds(candidate.votes)} </b> </span>
													: false
												}
												{
													candidate.percent*1>0
													? <div className='fullbar'><div className='bar bar-votes' style = {{width:candidate.percent+'%' }}></div></div>
													: false
												}
												
											</div>
										</li>										
									)
								}
								else {
									return false
								}
							})								
						}
						</ol>
					</div>
				</div>                
			)	
		}
		else {
			return false
		}
		


	}
}

export default StateView
